(function () {
class NbLandingSections {
  static init(root = document) {
    root.querySelectorAll('[data-nb-tabs]').forEach((tabs) => this.tabs(tabs));
    root.querySelectorAll('[data-nb-carousel]').forEach((carousel) => this.carousel(carousel));
    root.querySelectorAll('[data-nb-comparison]').forEach((comparison) => this.comparison(comparison));
    root.querySelectorAll('[data-nb-scroller]').forEach((scroller) => this.scroller(scroller));
  }

  static tabs(tabs) {
    if (tabs.dataset.nbReady) return;
    tabs.dataset.nbReady = 'true';
    const buttons = [...tabs.querySelectorAll('[role="tab"]')];
    const panels = [...tabs.querySelectorAll('[role="tabpanel"]')];
    const activate = (button) => {
      buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.id === button.getAttribute('aria-controls')));
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = buttons[(index + direction + buttons.length) % buttons.length];
        next.focus();
        activate(next);
      });
    });
  }

  static carousel(carousel) {
    if (carousel.dataset.nbReady) return;
    carousel.dataset.nbReady = 'true';
    const track = carousel.querySelector('[data-nb-carousel-track]');
    const slides = [...carousel.querySelectorAll('[data-nb-carousel-slide]')];
    const dots = [...carousel.querySelectorAll('[data-nb-carousel-dot]')];
    if (!track || !slides.length) return;
    const setCurrent = () => {
      const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', String(dotIndex === index)));
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => slides[index].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' })));
    track.addEventListener('scroll', setCurrent, { passive: true });
    setCurrent();
  }

  static comparison(comparison) {
    if (comparison.dataset.nbReady) return;
    comparison.dataset.nbReady = 'true';
    const before = comparison.querySelector('[data-nb-comparison-before]');
    const handle = comparison.querySelector('[data-nb-comparison-handle]');
    const beforeImage = before?.querySelector('img');
    if (!before || !handle) return;
    const update = (clientX) => {
      const rect = comparison.getBoundingClientRect();
      const value = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
      before.style.width = `${value}%`;
      handle.style.left = `${value}%`;
      if (beforeImage) beforeImage.style.width = `${rect.width}px`;
    };
    comparison.addEventListener('pointerdown', (event) => {
      comparison.setPointerCapture(event.pointerId);
      update(event.clientX);
    });
    comparison.addEventListener('pointermove', (event) => {
      if (comparison.hasPointerCapture(event.pointerId)) update(event.clientX);
    });
    window.addEventListener('resize', () => {
      if (beforeImage) beforeImage.style.width = `${comparison.clientWidth}px`;
    });
    if (beforeImage) beforeImage.style.width = `${comparison.clientWidth}px`;
  }

  static scroller(scroller) {
    if (scroller.dataset.nbReady) return;
    scroller.dataset.nbReady = 'true';
    const track = scroller.querySelector('[data-nb-scroll-track]');
    if (!track) return;
    scroller.querySelector('[data-nb-scroll-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .85, behavior: 'smooth' }));
    scroller.querySelector('[data-nb-scroll-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .85, behavior: 'smooth' }));
  }
}

document.addEventListener('DOMContentLoaded', () => NbLandingSections.init());
document.addEventListener('shopify:section:load', (event) => NbLandingSections.init(event.target));
})();
